export class CurationUpdateNode {
  private nodeId:string;

  constructor(nodeId:string) {
    this.nodeId = nodeId;
  }

  getNodeId():string {
    return this.nodeId;
  }


}
